import { Col, Row, Table } from "react-bootstrap";
import { isSuperAdmin } from "../../../Services/common";
import { getColorFromStatus } from "../../../Utils/appUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import Button from "../../_widgets/Button/Button";
import DateRangePicker from "../../_widgets/DateRangePicker/DateRangePicker";
import Input from "../../_widgets/Input/Input";
import MainLoader from "../../_widgets/Loader/MainLoader";
import ModalImport from "../../_widgets/Modal/ModalImport";
import NavBar from "../../_widgets/NavBar/NavBar";
import CustomPagination from "../../_widgets/Pagination/Pagination";
import Text from "../../_widgets/Text/Text";
import CustomTooltip from "../../_widgets/Tooltip/CustomTooltip";
import AnimatedPage from "../../AnimatedPage/AnimatedPage";
import EditMedicineCategoryModal from "./EditMedicineCategoryModal";
import ImageResource from "../../../Wrapper/ImageResource/ImageResource";

const MedicineCategoryUI = ({
  modalShow,
  importListing,
  exportList,
  importModal,
  importList,
  setSelectedRows,
  setImportModal,
  openImportModal,
  setModalShow,
  statusHandler,
  handleClose,
  medicineList,
  addMedicineData,
  setAddMedicineData,
  addMedicine,
  editMedicine,
  onPageChange,
  dates,
  setDates,
  datePickerStartRef,
  datePickerEndRef,
  searchQuery,
  setSearchQuery,
  loading,
  buttonLoading,
  Action,
  selectedRows,
  getMedicineCategoryList,
}) => {
  return (
    <AnimatedPage>
      <NavBar
        button="Add Medicine Category"
        buttonIcon="medicine"
        button2={!isSuperAdmin() && "Import Medicine Category"}
        buttonIcon2="download"
        button2onclick={openImportModal}
        heading="Medicine Category"
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        setModalShow={setModalShow}
        Icon="menu"
        buttons_responsive={true}
      />

      <ModalImport
        show={importModal}
        handleClose={() => setImportModal(false)}
        buttonLoading={buttonLoading}
        handleSaveClick={exportList}
        loading={loading}
        name="Medicine Category(s)"
        data={importList}
        importListing={importListing}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />

      <EditMedicineCategoryModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        handleClose={handleClose}
        addMedicineData={addMedicineData}
        addMedicine={addMedicine}
        editMedicine={editMedicine}
        buttonLoading={buttonLoading}
        setAddMedicineData={setAddMedicineData}
      />

      <div className="patient_list white_card">
        <div className="top_bar">
          <Text type="h2" text="" />
          <Row className="search_filter">
            <Col lg={4}>
              <div>
                <Input
                  placeholder="Search"
                  id="searchInput"
                  suffixIcon="search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onClickIconSuff={() => getMedicineCategoryList()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      getMedicineCategoryList();
                    }
                  }}
                  iconTooltip="Search"
                />
              </div>
            </Col>
            <Col lg={8}>
              <div className="date_range_picker">
                <DateRangePicker
                  startDate={dates?.startDate}
                  setStartDate={(startDate) => setDates({ ...dates, startDate })}
                  endDate={dates?.endDate}
                  setEndDate={(endDate) => setDates({ ...dates, endDate })}
                  onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                  datePickerStartRef={datePickerStartRef}
                  datePickerEndRef={datePickerEndRef}
                  showDateShortcuts={true}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : medicineList.data?.length > 0 ? (
            <>
              <div>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {medicineList?.data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <CustomTooltip text={data.name} placement={"top"}>
                              {data.name}
                            </CustomTooltip>
                          </td>

                          <td>
                            <CustomTooltip text={data.description} placement="top">
                              {data.description ? stringUtils.slice(data.description, 30) : "-"}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip
                              type="popover"
                              button={
                                <div className="p-1">
                                  <Button
                                    isLoading={buttonLoading}
                                    onClick={() => statusHandler(data)}
                                    buttonType="primary"
                                    text={data.status === "ACTIVE" ? "Deactivate" : "Activate"}
                                  />
                                </div>
                              }
                              placement="top"
                            >
                              <div className={`status status__${getColorFromStatus(data.status)}`}>
                                <Text text={stringUtils.capitalizeFirstLetter(data.status)} />
                              </div>
                            </CustomTooltip>
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <CustomTooltip text="Edit" placement={"top"}>
                                <Button
                                  className="p-1 bg-transparent border-0"
                                  icon={<IconResource type="edit" color="var(--light-text)" />}
                                  onClick={() => Action(data, "edit")}
                                />
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <CustomPagination
                activePage={medicineList?.current_page}
                onPageChange={onPageChange}
                pageLength={medicineList?.per_page}
                totalData={medicineList?.total}
                lastPage={medicineList?.last_page}
              />
            </>
          ) : (
            <>
              <div className="no_data position-relative">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text="There is no data to display. Try re-setting filters!" />
                <Button
                  buttonType="primary"
                  text="Add Medicine Category"
                  suffixIcon={<IconResource type="addMedicine" />}
                  onClick={() => setModalShow(true)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default MedicineCategoryUI;
